














import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api';

const baseUrl = '20240301JJRW';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '活动规则',
      path: `/${baseUrl}/rules`,
      id: 1,
    },
    {
      title: '风采展示',
      path: `/${baseUrl}/news`,
      id: 2,
    },
    {
      title: '发布活动',
      path: `/${baseUrl}/newsTypes`,
      id: 3,
    },
    // {
    //   title: '风采展示',
    //   path: `/${baseUrl}/list`,
    //   id: 4,
    // },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '“重庆经济人物新发现”主题宣传活动',
      url: location.href,
      subtitle: `聚焦标志性改革成果 谱写重庆发展新篇章`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '“重庆经济人物新发现”主题宣传活动',
        subtitle: `聚焦标志性改革成果 谱写重庆发展新篇章`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
